import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Panel from '../../../../../shared/components/Panel';
import ChartBuilder from '../../../../../shared/components/chart/ChartBuilder';
import { MetricOptions } from '../../../../../shared/components/filters/SalesMetricFilter';
import { columnDefs } from './columns';
import { getChartTheme } from '../../../../../shared/components/chart/chartThemeHelper';

export default function CompetitionTreemap({
  title, loading, data, metric,
}) {
  const theme = useSelector(store => store.theme);

  const isLightTheme = theme.className.endsWith('light');
  const tooltipBgColor = isLightTheme ? 'white' : '#2c2c2c';
  const tooltipTextColor = isLightTheme ? '#000000' : '#ffffff';
  const divStart = `<div style="padding-bottom: 10px; padding: 5px; background-color: ${tooltipBgColor}; color: ${tooltipTextColor};">`;
  const divEnd = '</div>';

  const chartOptions = {
    data: [{ title: metric.label, children: data || [] }],
    theme: getChartTheme(theme),
    height: 650,
    padding: {
      top: 10,
      bottom: 10,
    },
    title: {
      text: metric.label,
    },
    series: [
      {
        type: 'treemap',
        labelKey: 'competitor',
        sizeKey: metric.value,
        sizeName: metric.label,
        colorKey: metric.value,
        colorName: metric.label,
        gradient: true,
        colorRange: ['#f0ad4e', '#5cb85c'],
        labels: {
          value: {
            enabled: true,
          },
        },
        tooltip: {
          renderer: (params) => {
            const column = columnDefs.filter(item => item.field === metric.value)[0];
            if (!column) return '';
            return `${divStart}${params.datum.competitor} : ${column.valueFormatter({ value: params.datum[metric.value] })}${divEnd}`;
          },
        },
      },
    ],
    gradientLegend: {
      enabled: true,
      position: 'bottom',
      gradient: {
        preferredLength: 200,
      },
      scale: {
        label: {
          enabled: true,
        },
      },
    },
  };

  return (
    <Panel
      md={12}
      title={title}
      subhead={metric.label}
      showRefreshButton={false}
    >
      <Row>
        <Col lg={12}>
          <div style={{ textAlign: 'left' }}>
            <ChartBuilder
              chartOptions={chartOptions}
              parentRefresh={loading}
              chartHeight="700px"
            />
          </div>
        </Col>
      </Row>
    </Panel>
  );
}

CompetitionTreemap.defaultProps = {
  loading: false,
  data: null,
  metric: MetricOptions.SALES,
};

CompetitionTreemap.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  data: PropTypes.instanceOf(Array),
  metric: PropTypes.oneOf([...MetricOptions]),
};
